import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  buttonDelete: {
    paddingTop: '0px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  gochis: PropTypes.arrayOf(
    PropTypes.shape({
      invoicedAt: PropTypes.string,
      userDisplayName: PropTypes.number,
      menuName: PropTypes.string,
      transferAmount: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const InvoiceGochiTableBody = enhance(
  ({ classes, gochis, emptyRows, order, orderBy, page, limit }) => {
    // searchEs
    let sortedResult = [];
    if (orderBy === 'invoicedAt') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.invoicedAt;
        },
        order
      );
    } else if (orderBy === 'userDisplayName') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.userDisplayName;
        },
        order
      );
    } else if (orderBy === 'menuName') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.menuName;
        },
        order
      );
    } else if (orderBy === 'transferAmount') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.transferAmount;
        },
        order
      );
    } else {
      sortedResult = _.orderBy(gochis, orderBy, order);
    }

    return (
      <TableBody>
        {sortedResult
          // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((gochi, index) => {
            const key = index;
            return (
              <TableRow key={key} className={classes.verticalAlignTop}>
                <TableCell>{index + (page - 1) * limit + 1}</TableCell>
                <TableCell>{gochi.invoicedAt}</TableCell>
                <TableCell>{gochi.userDisplayName}</TableCell>
                <TableCell>{gochi.menuName}</TableCell>
                <TableCell>{gochi.transferAmount}</TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow>
            <TableCell colSpan={5} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(InvoiceGochiTableBody);
